"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filter = filter;
exports.name = void 0;
const name = exports.name = 'allcaps';
async function filter(text) {
  return "<span class=\"swan-text-all-caps\">".concat(text, "</span>");
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJuYW1lIiwiZXhwb3J0cyIsImZpbHRlciIsInRleHQiLCJjb25jYXQiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvZmlsdGVycy9hbGxjYXBzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBuYW1lID0gJ2FsbGNhcHMnO1xuXG5leHBvcnQgYXN5bmMgZnVuY3Rpb24gZmlsdGVyKHRoaXM6IGFueSwgdGV4dDogc3RyaW5nKTogUHJvbWlzZTxzdHJpbmc+IHtcbiAgcmV0dXJuIGA8c3BhbiBjbGFzcz1cInN3YW4tdGV4dC1hbGwtY2Fwc1wiPiR7dGV4dH08L3NwYW4+YDtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFPLE1BQU1BLElBQUksR0FBQUMsT0FBQSxDQUFBRCxJQUFBLEdBQUcsU0FBUztBQUV0QixlQUFlRSxNQUFNQSxDQUFZQyxJQUFZLEVBQW1CO0VBQ3JFLDZDQUFBQyxNQUFBLENBQTJDRCxJQUFJO0FBQ2pEIiwiaWdub3JlTGlzdCI6W119